import { Image, OverlayTrigger } from 'react-bootstrap'
import React, { useState } from 'react'
import '../../index.css'
import { connect } from 'react-redux'
import { addArticleTypeImage } from '../../store/actions/index'
import { RenderImage } from './ImageViewer'

const UploadImage = ({ setFilename, setImage }) => {
    const [previewImage, setPreviewImage] = useState()

    const handleChange = (imageInput) => {
        if (imageInput.target.files[0]) {
            const file = imageInput.target.files[0]
            var pattern = /image-*/;

            if (!file.type.match(pattern)) {
                alert('Das Format des Bildes ist nicht korrekt.')
                return;
            }

            setPreviewImage(URL.createObjectURL(file))
            //console.log("FILE")
            //console.log(file)
            //console.log(URL.createObjectURL(file))
            openFiles(imageInput)
        }
    }

    function openFiles(evt) {
        console.log(evt.target)
        var file = evt.target.files[0]
        setFilename(file.name)

        var reader = new FileReader()

        reader.onload = (function (f) {
            return function (e) {
                var arrayBuffer = e.target.result
                //console.log("e target result")
                //console.log(arrayBuffer)
                var bytes = new Uint8Array(arrayBuffer)
                var binary = ''

                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i])
                }
                //console.log("Binary")
                //console.log(binary)
                var binaryString = btoa(binary);
                setImage(binaryString)

                //console.log("Binary String")
                //console.log(binaryString)

            };
        })(file)

        reader.readAsArrayBuffer(file)
    }

    return (
        <div className="form-inline">
            <input required className="form-control" type="file" onChange={handleChange} accept="image/*" />
            &nbsp;
            {previewImage != null && RenderImage(previewImage)}
        </div>
    );
}

export default UploadImage